// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"751":"492956f8","823":"a25b81c5"}[chunkId] + ".chunk.js";
};